export enum WorkspaceRoutes {
  ROOT = "",
  SETTINGS = "settings",
  MEMBERS = "members",
  IMPORT = "import",
  IMPORT_LARGE = "import-large",
  REPORTS = "reports",
  API_USAGE_ANALYTICS = "api-usage-analytics",
  API_CATEGORY_ANALYTICS = "api-category-analytics",
  DOWNLOADS = "downloads",
  RECOMPARE = "recompare",

  // Data Source List Views
  SURVEY_ROOT = "surveys",
  CHAT_ROOT = "chats",

  // Data Source Detail Views
  SURVEY = "survey",
  CHAT = "chat",

  // Model Lists Views
  CATEGORY_ROOT = "category-models",
  CATEGORY_PUNCHES = "category-punches",
  SENTIMENT_ROOT = "sentiment-models",
  TOPIC_ROOT = "topic-models",
  EMOTION_ROOT = "emotion-models",
  INTENT_ROOT = "intent-models",

  // Model Version Detail Views
  CATEGORY = "category",
  SENTIMENT = "sentiment",
  SENTIMENT_LEXICON = "sentiment-lexicon",
  TOPIC = "topic",
  EMOTION = "emotion",
  INTENT = "intent",

  // Pipeline Progress Views
  PIPELINE_PROGRESS = "pipeline-progress",
  START = "start",
  TEST = "test",
}
